import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "3413.333",
  height: "3413.333",
  version: "1.0",
  viewBox: "0 0 2560 2560"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 1280v1280h2560V0H0z" }, null, -1)
  ])))
}
export default { render: render }